module.exports = __webpack_public_path__ + "static/media/month_02.ad37e0ed.png";